import { V3ModalComponent } from '#components';
import { V3PopupComponent } from '#components';
import { decrypt } from '~/utility/encryption';
import { popupBackHandler } from '~/composables/popupBackHandler'
import { setPostAuthRedirect } from '~/utility/authRedirect';
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';


const getBannerId = (banner: any) =>
  banner?.banner_id ??
  banner?.bannerId ??
  banner?.props?.banner_id ??
  banner?.id ??
  banner?.props?.id ??
  banner?.sku_id ??
  banner?.skuId ??
  banner?.product?.sku_id ??
  banner?.product?.skuId ??
  banner?.product?.id ??
  banner?.product_id ??
  null;

const buildBannerClickPayload = (
  banner: any,
  options: {
    position?: number;
    campaignName?: string;
    layoutPosition?: number;
    layoutName?: string;
    bannerId?: string | number | null;
  } = {},
) => {
  const bannerId = options.bannerId ?? getBannerId(banner);
  if (!bannerId) return null;

  const resolvedLayoutPosition =
    typeof options.layoutPosition === 'number'
      ? options.layoutPosition
      : banner?.layout_position ??
        banner?.props?.layout_position ??
        banner?.layoutPosition ??
        (typeof banner?.props?.layoutPosition === 'number' ? banner.props.layoutPosition : undefined);
  const resolvedLayoutName =
    options.layoutName ||
    banner?.layout_name ||
    banner?.props?.layout_name ||
    banner?.layoutName ||
    banner?.layout;
  const resolvedBannerPosition =
    typeof options.position === 'number'
      ? options.position
      : banner?.banner_position ??
        banner?.props?.banner_position ??
        banner?.bannerPosition ??
        banner?.props?.bannerPosition;

  return {
    banner_id: String(bannerId),
    banner_position:
      typeof resolvedBannerPosition === 'number'
        ? String(resolvedBannerPosition)
        : undefined,
    campaign_name:
      options.campaignName ??
      banner?.meta?.title ??
      banner?.meta?.header ??
      banner?.title ??
      undefined,
    link_url: banner?.action?.target ?? banner?.redirectionUrl ?? undefined,
    product_id:
      banner?.product?.id ??
      banner?.product?.sku_id ??
      banner?.sku_id ??
      banner?.product_id ??
      undefined,
    product_name:
      banner?.product?.name ??
      banner?.product_name ??
      banner?.name ??
      undefined,
    layout_position:
      typeof resolvedLayoutPosition === 'number'
        ? resolvedLayoutPosition
        : undefined,
    layout_name: resolvedLayoutName,
  };
};

export const trackBannerClicked = (
  banner: any,
  options: {
    position?: number;
    campaignName?: string;
    layoutPosition?: number;
    layoutName?: string;
    bannerId?: string | number | null;
  } = {},
) => {
  
  const payload = buildBannerClickPayload(banner, options);
 
  const analyticsEvents = useAnalyticsEvents();
  useAnalytics(analyticsEvents.BANNER_CLICKED, payload);

  if (process.client && typeof window !== 'undefined' && typeof (window as any).dht === 'function') {
    (window as any).dht('cta_click');
  }
};

export const useBannerAction = async (bannerItem: any, bannerHeader: any, positionIndex: number, layout: string) => {

  const auth = useAuth();
  const isAuthenticated = auth && auth.access_token;
  // GoogleAnalytics.cta({
  //   [EventParameter.CTA_NAME]: 'banner_click',
  //   [EventParameter.CLICK_SCOPE]: 'component',
  //   [EventParameter.COMPONENT_NAME]: bannerItem?.meta?.title || bannerHeader || '',
  //   [EventParameter.COMPONENT_ID]: bannerItem?.scope?.values[0],
  //   [EventParameter.COMPONENT_TYPE]: bannerItem?.componentType,
  //   [EventParameter.BANNER_ID]: bannerItem?.banner_id,
  //   [EventParameter.BANNER_POSITION]: bannerItem?.banner_position,
  //   [EventParameter.LAYOUT_NAME]: bannerItem?.layout_name,
  //   [EventParameter.LAYOUT_POSITION]: bannerItem?.layout_position,
  //   [EventParameter.TARGET_URL]: bannerItem?.action?.target || '',
  //   [EventParameter.REDIRECTION_TYPE]: bannerItem?.action?.type || bannerItem?.redirectionType || 'href'
  // })

  GoogleAnalytics.component_event({
    [EventParameter.ACTION]: 'component_item_clicked',
    [EventParameter.COMPONENT_NAME]: bannerItem?.meta?.title || bannerHeader || '',
    [EventParameter.ITEM_TITLE]: bannerItem?.title || 'unknown',
    [EventParameter.BANNER_ID]: bannerItem?.banner_id ?? 'unknown',
    [EventParameter.BANNER_POSITION]: bannerItem?.banner_position ?? 'unknown',
    [EventParameter.LAYOUT_NAME]: bannerItem?.layout_name ?? 'unknown',
    [EventParameter.LAYOUT_POSITION]: bannerItem?.layout_position ??'unknown',

   });

  const action = bannerItem?.action || {
    type: bannerItem?.redirectionType || 'href',
    target: bannerItem?.redirectionUrl || '',
  };
  const { type, target } = action || {};
  let ctaName = "";
  if (!type || target === undefined || target === null) {
    trackBannerClicked(bannerItem, {
      position: typeof positionIndex === 'number' ? positionIndex + 1 : undefined,
      campaignName: bannerHeader,
      layoutPosition: bannerItem?.layout_position,
      layoutName: layout || bannerItem?.layout_name,
      bannerId: bannerItem?.banner_id,
    });
    return;
  }
  if (target !== '') {
    const currentUrl = window.location.href;
    if (currentUrl.includes("collections")) {
      const parts = currentUrl.split("collections/");
      if (parts.length > 1) {
        ctaName = parts[1]
      }
    } else if (currentUrl.includes("categories")) {
      ctaName = "clp"
    } else if (currentUrl.includes("aboutUs")) {
      ctaName = "aboutus"
    } else {
      ctaName = "homepage"
    }
    const normalizedType = typeof type === 'string' ? type.toLowerCase() : '';
    if (normalizedType === 'href') {
      trackBannerClicked(bannerItem, {
        position: typeof positionIndex === 'number' ? positionIndex + 1 : undefined,
        campaignName: bannerHeader,
        layoutPosition: bannerItem?.layout_position,
        layoutName: layout || bannerItem?.layout_name,
        bannerId: bannerItem?.banner_id,
      });
      if (openInternalLinkAsExternal(target)) return;
      const redirectArray = target.split('?');
      const params = new URLSearchParams(redirectArray[1]);
      const queryObject: Record<string, string> = {};
      for (const [key, value] of params.entries()) {
        if (key) {
          queryObject[key] = value;
        }
      }

      if (redirectArray[0] === '/loans') {
        if (isAuthenticated) {
          if (/^https?:\/\//.test(redirectArray[0])) {
            window.open(redirectArray[0], '_blank', 'noopener,noreferrer');
          } else {
            await navigateTo({ path: redirectArray[0], query: queryObject });
          }
          return;
        } else {
          await _authenticateUser(async () => {
          if (/^https?:\/\//.test(redirectArray[0])) {
              window.open(redirectArray[0], '_blank', 'noopener,noreferrer');
            } else {
              await navigateTo({ path: redirectArray[0], query: queryObject });
            }
          }, () => {});
          return;
        }
      } else {
        setPostAuthRedirect({ path: redirectArray[0], query: queryObject,});
        if (/^https?:\/\//.test(redirectArray[0])) {
          window.open(redirectArray[0], '_blank', 'noopener,noreferrer');
        } else {
        await navigateTo({ path: redirectArray[0], query: queryObject });
      }
        return;
      }
    } else if (normalizedType === 'external') {
      if (isAuthenticated) {
        trackBannerClicked(bannerItem, {
          position: typeof positionIndex === 'number' ? positionIndex + 1 : undefined,
          campaignName: bannerHeader,
          layoutPosition: bannerItem?.layout_position,
          layoutName: layout || bannerItem?.layout_name,
          bannerId: bannerItem?.banner_id,
        });
        await useExternalLinkHandler(target,  { openInNewTab: true });
        return;
      } else {
        trackBannerClicked(bannerItem, {
          position: typeof positionIndex === 'number' ? positionIndex + 1 : undefined,
          campaignName: bannerHeader,
          layoutPosition: bannerItem?.layout_position,
          layoutName: layout || bannerItem?.layout_name,
          bannerId: bannerItem?.banner_id,
        });
        setPostAuthRedirect({ path: target, redirectionType: 'external' });
        await _authenticateUser(async () => {
        }, () => {});
        return;
      }
    }
    
    const payload: { [key: string]: any } = {
      banner_id: bannerItem?.banner_id
    };
    if(/^\/?providers\//.test(target)) {
      payload.scope_type = 'PLP',
      payload.provider_id = target.match(/^\/?providers\/(.*)/)[1];
    }
    if(/^\/?products\//.test(target)) {
      payload.scope_type = 'PDP',
      payload.sku_id = target.match(/^\/?products\/(.*)/)[1];
    }
    if(/^\/?categories\/search-v2/.test(target) || /^\/?filter\/v2/.test(target)) {
      const queryParams = Object.fromEntries(new URLSearchParams(target.split('?')[1]));
      payload.scope_type = 'Dynamic';
      payload.params = queryParams;
    }

    if(isAuthenticated && payload.banner_id && payload.scope_type) {
      await useAPIHandler("post", "/banners/storeBannerClick", {
        body: payload,
        auth: true,
      });
    }
    trackBannerClicked(bannerItem, {
      position: typeof positionIndex === 'number' ? positionIndex + 1 : undefined,
      campaignName: bannerHeader,
      layoutPosition: bannerItem?.layout_position,
      layoutName: layout || bannerItem?.layout_name,
      bannerId: bannerItem?.banner_id,
    });
    return;
  }
}

export const useItemAction = async (
  bannerItem: any,
  bannerHeader: any,
  bannerId: string,
  positionIndex: number,
  layout: any,
) => {

  const { redirectionUrl, redirectionType } = bannerItem;
  const auth = useAuth();
  const isAuthenticated = auth && auth.access_token;
  // GoogleAnalytics.cta({
  //   [EventParameter.CTA_NAME]: 'banner_click',
  //   [EventParameter.CLICK_SCOPE]: 'item',
  //   [EventParameter.ITEM_TITLE]: bannerItem?.title || '',
  //   [EventParameter.COMPONENT_NAME]: bannerHeader || '',
  //   [EventParameter.BANNER_ID]: bannerItem?.banner_id,
  //   [EventParameter.BANNER_POSITION]: bannerItem?.banner_position,
  //   [EventParameter.LAYOUT_POSITION]: bannerItem?.layout_position,
  //   [EventParameter.LAYOUT_NAME]: bannerItem?.layout_name,
  //   [EventParameter.TARGET_URL]: bannerItem?.redirectionUrl || '',
  //   [EventParameter.REDIRECTION_TYPE]: bannerItem?.redirectionType || 'href'
  // })

    GoogleAnalytics.component_event({
    [EventParameter.ACTION]:'component_click',
    [EventParameter.COMPONENT_NAME]: bannerItem?.meta?.title || bannerHeader || '',
    [EventParameter.BANNER_ID]: bannerItem?.banner_id,
    [EventParameter.BANNER_POSITION]: bannerItem?.banner_position,
    [EventParameter.ITEM_TITLE]: bannerItem?.title || 'na',
    [EventParameter.LAYOUT_NAME]: bannerItem?.layout_name,
    [EventParameter.LAYOUT_POSITION]: bannerItem?.layout_position,

    })

  if (!redirectionUrl || typeof redirectionUrl !== 'string') return;

  const urlObj = new URL(redirectionUrl, window.location.origin);
  const path = urlObj.pathname;
  const queryObject: Record<string, string> = {};
  urlObj.searchParams.forEach((value, key) => {
    if (key) queryObject[key] = value;
  });

  trackBannerClicked(bannerItem, {
    position: typeof positionIndex === 'number' ? positionIndex + 1 : undefined,
    campaignName: bannerHeader,
    layoutPosition: bannerItem?.layout_position,
    layoutName: layout || bannerItem?.layout_name,
    bannerId: bannerId || bannerItem?.banner_id,
  });

  if (bannerHeader === 'Financial Services') {
    
    if (isAuthenticated) {
      if (redirectionType === 'external') {
        await useExternalLinkHandler(redirectionUrl, { openInNewTab: true });
      } else {
        if (/^https?:\/\//.test(redirectionUrl)) {
          window.open(redirectionUrl, '_blank', 'noopener,noreferrer');
        } else {
          await navigateTo({ path, query: queryObject });
        }
      }
      return;
    }

    setPostAuthRedirect({
      path: redirectionType === 'external' ? redirectionUrl : path,
      query: redirectionType === 'external' ? {} : queryObject,
      redirectionType,
    });

    await _authenticateUser(() => {}, () => {});
    return;
  }

  // Determine CTA name for analytics
  const currentUrl = window.location.href;
  let ctaName = "homepage"; // default
  if (currentUrl.includes("collections")) {
    const parts = currentUrl.split("collections/");
    if (parts.length > 1) ctaName = parts[1] || "collections";
  } else if (currentUrl.includes("categories")) {
    ctaName = "clp";
  } else if (currentUrl.includes("aboutUs")) {
    ctaName = "aboutus";
  }

  // External link: open in new tab
  if (redirectionType === 'external') {
    if (isAuthenticated) {
      await useExternalLinkHandler(redirectionUrl, { openInNewTab: true });
    } else {
      setPostAuthRedirect({
        path: redirectionUrl,
        redirectionType: 'external',
      });
      await _authenticateUser(() => {}, () => {});
    }
    return;
  }

  if (openInternalLinkAsExternal(redirectionUrl)) return;

  try {
    if (/^https?:\/\//.test(redirectionUrl)) {
      window.open(redirectionUrl, '_blank', 'noopener,noreferrer');
    } else {
      await navigateTo({ path, query: queryObject });
    }
  } catch (error) {
    console.error('Invalid internal URL:', redirectionUrl, error);
  }

  // Commit analytics event
  //commitEvent(bannerItem, ctaName, bannerHeader, positionIndex + 1, layout);

  const authenticate = useAuth();
  const authenticated = authenticate && authenticate.access_token;
  const payload: { [key: string]: any } = {
      banner_id: bannerId
    };
    if(/^\/?providers\//.test(redirectionUrl)) {
      payload.scope_type = 'PLP',
      payload.provider_id = redirectionUrl.match(/^\/?providers\/(.*)/)[1];
    }
    if(/^\/?products\//.test(redirectionUrl)) {
      payload.scope_type = 'PDP',
      payload.sku_id = redirectionUrl.match(/^\/?products\/(.*)/)[1];
    }
    if(/^\/?categories\/search-v2/.test(redirectionUrl) || /^\/?filter\/v2/.test(redirectionUrl)) {
      const queryParams = Object.fromEntries(new URLSearchParams(redirectionUrl.split('?')[1]));
      payload.scope_type = 'Dynamic';
      payload.params = queryParams;
    }

    if(authenticated && bannerId && payload.scope_type) {
      await useAPIHandler("post", "/banners/storeBannerClick", {
        body: payload,
        auth: true,
      });
    }
};

const _authenticateUser = async (
  onSuccess: () => void,
  onClose: () => void
) => {
  const auth = useAuth();

  if (auth?.access_token) {
    onSuccess();
    return;
  }
  const { isPopupOpen, openPopup, closePopup } = popupBackHandler()
  openPopup();
};
